exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\r\n    .receiptTemplate {\r\n        background-color: white;\r\n        height: 100%;\r\n        width: 100%;\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        margin: 0;\r\n        padding: 15px;\r\n        font-size: 14px;\r\n        line-height: 18px;\r\n        z-index: 1000;\r\n    }\r\n}\r\n", ""]);

// exports
